import React from 'react';
import { Mouvement } from '@mairistem/comptabilite';
import CovidComponent from '../../../components/Mouvement/Panel/CovidComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import LignePanel from './LignePanel';

class CovidPanel extends LignePanel {
  constructor(isMandatory = false) {
    super(isMandatory);
    this.code = CODE_PANEL.COVID;
    this.icon = { name: 'syringe' };
  }

  getLibelle = () => 'Covid 19';

  isEmpty = (data: Mouvement) => !data?.lignes?.find((ligne) => ligne?.covid19);

  getComponent = function getComponent(
    data: any,
    onChange: any,
    handlePin: any,
  ): React.ReactElement {
    return (
      <CovidComponent
        data={data}
        handlePin={handlePin}
        onChange={onChange}
        panel={this}
      />
    );
  };
}

export default CovidPanel;
